
export const sliderItems = [
    {
        id:1,
        img:"./cart2.png",
        title: "SUPER JOGGER",
        desc:"DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
        bg:"linear-gradient( #30e9ff,  #0d0551)",
     },

     {
        id:2,
        img:"./cart5.png",
        title: "CORPORATE WEARS",
        desc:"DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
        bg:"#5F0F40",
     },
     {
        id:3,
        img:"./cart3.png",
        title: "PARTY WEARS",
        desc:"DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
        bg:"#BD6267",
     },

     {
      id:4,
      img:"./cart4.png",
      title: "MULTI-PURPOSE BUY AND SELL",
      desc:"OPEN PLATFORM FOR BUYING AND SELLING.",
      bg:"#A9AACE",
   }
   
   
    ];
        
    
      export const categories = [
       {
         id:1,
         img:"https://images.pexels.com/photos/3768005/pexels-photo-3768005.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
         title: "SHIRT STYLE",
       },
       {
         id:2,
         img:"https://images.pexels.com/photos/996329/pexels-photo-996329.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
         title:"T-SHIRT STYLE",
       },
       {
         id:2,
         img:"https://images.pexels.com/photos/1598507/pexels-photo-1598507.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
         title:"CHOICE JEANS",
       }



      ];

export const popularProducts = [
   {
      id:1,
      img:"https://images.pexels.com/photos/7319172/pexels-photo-7319172.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",



   },
   {
      id:2,
      img:"https://images.pexels.com/photos/1500881/pexels-photo-1500881.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
   },
   {
      id:3,
      img:"https://images.pexels.com/photos/5184688/pexels-photo-5184688.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
   },


   {
      id:4,
      img:"https://images.unsplash.com/photo-1556306535-0f09a537f0a3?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80",
   },
   {
      id:5,
      img:"https://images.unsplash.com/photo-1523170335258-f5ed11844a49?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80",
   },
   {
      id:6,
      img:"https://images.unsplash.com/photo-1608042314453-ae338d80c427?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=510&q=80",
   },
   
   {
      id:7,
      img:"https://images.unsplash.com/photo-1595950653106-6c9ebd614d3a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
   },
   {
      id:7,
      img:"https://images.unsplash.com/photo-1591047139829-d91aecb6caea?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=436&q=80",
   },
   
   





];











